import { useMemo } from 'react';
import { useLocation, useMatches } from 'react-router';
import {
    resolveEffectivePrimaryCategoryPath,
    type RouteMatchWithPrimaryCategoryPath,
} from '@/lib/catalog-menu-primary-category';

/** Client-side primary category path for catalog menu L1 pre-selection. */
export function useEffectivePrimaryCategoryPath(): string | null {
    const matches = useMatches() as RouteMatchWithPrimaryCategoryPath[];
    const { pathname } = useLocation();

    return useMemo(
        () =>
            resolveEffectivePrimaryCategoryPath({
                pathname,
                matches,
            }),
        [pathname, matches]
    );
}
